// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2vvNL","row":"Node_row__1LoMa","label":"Node_label__1ePPq","footer":"Node_footer__jrQZ2"};